module.exports = __webpack_public_path__ + "img/36ne.ee2fe1d8.svg";